import React, { Component, ReactNode } from 'react';
import { T, rgba } from '../../utils/adminTheme';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('❌ React Fehler abgefangen:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
          background: T.bg,
          fontFamily: T.body,
        }}>
          <div style={{
            background: T.surface,
            border: `1px solid ${T.line}`,
            borderRadius: T.r.lg,
            padding: '36px 28px',
            maxWidth: 420,
            width: '100%',
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 44, marginBottom: 16 }}>😬</div>
            <h2 style={{ margin: '0 0 8px', fontFamily: T.display, fontStyle: 'italic', fontSize: 22, fontWeight: 500, color: T.text }}>
              Etwas ist schiefgelaufen
            </h2>
            <p style={{ margin: '0 0 16px', color: T.muted, fontSize: 14 }}>
              Ein unerwarteter Fehler ist aufgetreten.
            </p>
            {this.state.error && (
              <pre style={{
                background: rgba('#e53935', 0.06),
                border: `1px solid ${rgba('#e53935', 0.2)}`,
                borderRadius: T.r.md,
                padding: '10px 12px',
                fontSize: 12,
                color: '#c62828',
                textAlign: 'left',
                overflowX: 'auto',
                marginBottom: 20,
                fontFamily: T.mono,
              }}>
                {this.state.error.message}
              </pre>
            )}
            <button
              onClick={this.handleReset}
              style={{
                width: '100%',
                padding: '12px 0',
                background: T.accent,
                border: 'none',
                borderRadius: T.r.md,
                fontFamily: T.body,
                fontSize: 15,
                fontWeight: 600,
                color: '#fff',
                cursor: 'pointer',
              }}
            >
              Seite neu laden
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
